<template>
  <div class="SCity">
    <el-input
      placeholder="请选择城市"
      readonly
      v-model="selText"
      @focus="showCityDialog"
    >
    </el-input>
    <div class="city-components" v-if="showCity">
      <div class="close" @click="close">关闭</div>
      <ul class="filter-tabar clearfix">
        <li
          v-for="(item, index) in cityListKey"
          v-bind:key="index"
          :class="{ active: upCityListIndex == index }"
          @mouseover="upCityListKey(index)"
        >
          {{ item }}
        </li>
      </ul>
      <div class="city-content">
        <ul
          v-for="(item, index) in upCityList"
          class="clearfix"
          v-bind:key="index"
        >
          <label for="">{{ item.ckey }}</label>
          <li
            v-for="(ritem, index) in item.cityList"
            @click="switchKey(ritem)"
            v-bind:key="index"
          >
            {{ ritem.cityName }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import cities from "./data.json";
export default {
  name: "SCity",
  props: {
    value: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      selText: "",
      showCity: false,
      dataList: cities.list,
      upCityListIndex: "",
      upCityList: ""
    };
  },
  mounted() {
    const { value } = this;
    this.selText = value;
  },
  watch: {
    value(v, a) {
      this.selText = v;
    }
  },
  computed: {
    cityListData() {
      let map = {}; // 处理过后的数据对象
      let temps = []; // 临时变量
      this.dataList.map(item => {
        if (item.pinYin) {
          let ekey = item.pinYin.charAt(0).toUpperCase(); // 根据key值的第一个字母分组，并且转换成大写
          temps = map[ekey] || []; // 如果map里面有这个key了，就取，没有就是空数组
          temps.push({
            pinYin: item.pinYin,
            cityName: item.cityName
          });
          map[ekey] = temps;
        }
      });
      let list = [];
      for (let gkey in map) {
        list.push({
          ckey: gkey,
          cityList: map[gkey]
        });
      }
      list = list.sort(
        (li1, li2) => li1.ckey.charCodeAt(0) - li2.ckey.charCodeAt(0)
      );

      let chunk = 4;
      let result = [];
      for (var i = 0, j = list.length; i < j; i += chunk) {
        result.push(list.slice(i, i + chunk));
      }
      return result;
    },
    cityListKey() {
      let cityListKey = [];
      this.cityListData.map(item => {
        let ckeys = "";
        item.map(ritem => {
          ckeys += ritem.ckey;
        });
        cityListKey.push(ckeys);
      });
      this.upCityList = this.cityListData[0];
      return cityListKey;
    }
  },

  methods: {
    upCityListKey(index) {
      this.upCityListIndex = index;
      this.upCityList = this.cityListData[index];
    },
    showCityDialog() {
      this.showCity = true;
    },
    close() {
      this.showCity = false;
    },
    switchKey(item) {
      this.showCity = false;
      this.selText = item.cityName;
      this.$emit("input", item.cityName);
    }
  }
};
</script>

<style scoped lang="less">
@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/components/SCity/index.vue